import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class ImportLessonsRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    let { planbook, rotationCalendar } = this.modelFor("planbookv5")
    if (planbook && planbook.attributes.flags.isImportingLessons) {
      return this.modelFor("planbook")
    } else {
      return this.transitionTo("planbookv5.planner.week")
    }
  }
}
